import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import * as AdminActions from "../../../../actions/admin";
import * as RaceActions from "../../../../actions/race";
import {CompressList, isDefined, removeCommaWhitespace, removeNonDigits} from "../../../../../../common/src/util/lib";
import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import {push} from "react-router-redux";
import {ROUTE_CLUB} from "../../../../constants/routeconstants";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

export const defaultState = {
    Pointsystem: 'Land',
    KunSportsduer: 0,
    AntalDuerPrSlag: '',
    editIx: null
};

class ChampionshipRaces extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool,
        championship: PropTypes.object.isRequired,
    };

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = defaultState
    }

    componentDidMount() {
        this.props.dispatch(RaceActions.getRaces());
        this.props.dispatch(AdminActions.getListItems('station'));
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.editMode || ((nextProps.championship === null && this.props.championship !== null) || (nextProps.championship !== null && (this.props.championship === null || this.props.championship.RecNr !== nextProps.championship.RecNr)))) this.setState(defaultState);
    }

    fields = [];
    render() {
        // To prevent calculations before races are read
        if (!this.props.race.isRacesRead || !this.props.admin.stations.size) return null;

        const editMode = this.props.editMode;

        let pickedRows = []
        let unpickedRows = []

        this.props.race.races.sort((r1, r2)=>{
            if (r1.Uge < r2.Uge) return -1;
            if (r1.Uge > r2.Uge) return 1;
            if (r1.Farvekode < r2.Farvekode) return -1;
            if (r1.Farvekode > r2.Farvekode) return 1;
            return 0;
        }).forEach(race => {
            const championshipRace = this.props.championship.Mesterskabsflyvnings.get(race.Nr);
            const station = this.props.admin.stations.get(race.Station);

            const sections = CompressList(race.Sektioner).items.join(',');
            const groups = CompressList(race.Sektionsgrupper).items.join(',');

            const sectionsString = (race.Sektioner === '' || race.Sektioner === null) ? null : ` Sektioner ${sections}`;
            const sectionGroupsString = (race.Sektionsgrupper === '' || race.Sektionsgrupper === null) ? null : ` Grupper ${groups}`;
            const raceString = `${race.Uge} - ${race.Farvekode}${isDefined(station) ? ' (' + station.Navn + ')' : ''}${sectionsString === null ? '' : sectionsString}${sectionGroupsString === null ? '' : sectionGroupsString}`;

            // if picked for championship
            if(championshipRace){
                pickedRows.push(
                    <tr key={championshipRace.Kapflyvningsnr} id={'picked-row-' + championshipRace.Kapflyvningsnr}>
                        <td>{race.Uge}</td>
                        <td>{removeNonDigits(race.Farvekode)}</td>
                        <td>{race.LMU}</td>
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{race.Sektion}</td> : null}
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{groups}</td> : null}
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{sections}</td> : null}
                        <td>{isDefined(station) ? `${station.Stationsnr} ${station.Navn}` : ''}</td>
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{
                            this.state.editIx === championshipRace.Kapflyvningsnr ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.enum}
                                    placeholder="false"
                                    className="field175"
                                    containerClassName="display-inline-block"
                                    tabIndex={1}
                                    name="Pointsystem"
                                    id="Pointsystem"
                                    value={this.state.Pointsystem}
                                    options={[
                                        {key: 'Land', value: 'Land'},
                                        {key: 'Gruppe', value: 'Gruppe'},
                                        {key: 'Sektion', value: 'Sektion'},
                                        {key: 'Område', value: 'Område'},
                                        {key: 'Region', value: 'Region'},
                                        //{key: 'Lag', value: 'Lag'},
                                    ]}
                                    autoCheckErrors={true}
                                    required={true}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[0] = instance; }}

                            /> : championshipRace.Pointsystem
                        }</td> : null}
                        <td className={'boolean'}>{
                            this.state.editIx === championshipRace.Kapflyvningsnr ?
                            <input
                                id="KunSportsduer"
                                name="KunSportsduer"
                                type="checkbox"
                                checked={this.state.KunSportsduer !== null && this.state.KunSportsduer !== 0}
                                onChange = {this.onCheckboxClick}
                            />
                            : championshipRace.KunSportsduer ? 'X' : ''
                        }</td>
                        <td>{
                            this.state.editIx === championshipRace.Kapflyvningsnr ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.int}
                                    placeholder=""
                                    className="field-1 very-small-field"
                                    containerClassName="display-inline-block"
                                    name="AntalDuerPrSlag"
                                    id="AntalDuerPrSlag"
                                    value={this.state.AntalDuerPrSlag}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[1] = instance; }}
                                />
                                : championshipRace.AntalDuerPrSlag === null ? '' : championshipRace.AntalDuerPrSlag
                        }</td>
                        <td>{
                            this.state.editIx === championshipRace.Kapflyvningsnr ? [
                                <i key={0} className="fa fa-save clickable" title="Gem kapflyvning" onClick={()=>{this.saveRow(championshipRace.Kapflyvningsnr)}}/>,
                                <i key={1} className="fa fa-undo clickable" title="Annuller" onClick={this.cancelEdit}/>
                            ] : [
                                <i key={0} className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                                    if (this.state.editIx === null){
                                        this.setState({
                                            Pointsystem: championshipRace.Pointsystem,
                                            KunSportsduer: championshipRace.KunSportsduer,
                                            AntalDuerPrSlag: championshipRace.AntalDuerPrSlag === null ? '' : championshipRace.AntalDuerPrSlag.toString(),
                                            editIx: championshipRace.Kapflyvningsnr,
                                        });
                                    }
                                }}/>,
                                <i key={1}
                                   className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet fra mesterskab" onClick={() => {
                                    if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at fjerne <b>{raceString}</b> fra mesterskabet?</span>, () => {
                                        this.props.dispatch(AdminActions.deleteChampionshipRace(championshipRace.MesterskabsId, championshipRace.Kapflyvningsnr, () => {
                                            NotificationManager.success(`Kapflyvningen ${raceString} er slettet fra mesterskabet`, "Sletning", 4000);
                                            setTimeout(function () {
                                                const currentRow = document.getElementById('unpicked-row-' + championshipRace.Kapflyvningsnr);
                                                currentRow.scrollIntoView(false);
                                            });
                                        }));
                                    });
                                }}/>
                            ]
                        }</td>
                    </tr>
                )
            } else {
                unpickedRows.push(
                    <div
                        key={race.Nr}
                        id={"unpicked-row-" + race.Nr}
                        className={'unpicked-row'}
                        onDoubleClick={() => {
                            this.props.dispatch(AdminActions.createChampionshipRace(this.props.championship.RecNr, race.Nr, (entity)=> {
                                NotificationManager.success(`Kapflyvningen ${raceString} er tilføjet til mesterskabet`, "Oprettelse", 4000);
                                setTimeout(function () {
                                    const currentRow = document.getElementById('picked-row-' + race.Nr);
                                    currentRow.scrollIntoView(false);
                                });
                            }));
                        }}
                    >
                        <span className={'header'}>{raceString}</span>
                    </div>
                )
            }
        });

        return <div className={"form-page championship-basics championship-races " + (editMode ? "editable" : "read-only")}>
            <div className={'outer-content upper'}>
                <div className={'inner-content unpicked-list'}>
                    {unpickedRows}
                </div>
            </div>
            <div className={'outer-content lower'}>
                <div className={'inner-content picked-table'}>
                    <table className="data-table">
                        <thead>
                        <tr>
                            <th>Uge</th>
                            <th>KFK</th>
                            <th>LMU</th>
                            {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektion</th> : null}
                            {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sek.grupper</th> : null}
                            {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektioner</th> : null}
                            <th>Station</th>
                            {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Pointsystem</th> : null}
                            <th>Sportsduer</th>
                            <th>Duer pr slag</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {pickedRows}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onCheckboxClick = (e) => {
        this.setState({[e.target.name]: e.target.checked ? 1 : 0})
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    cancelEdit = () => {
        this.setState(defaultState);
    };

    saveRow = (raceNo) => {
        if (this.allInputValid()) {
            const championship = this.props.championship;
            const race = this.props.race.races.get(raceNo)
            const station = this.props.admin.stations.get(race.Station)
            const entity = {
                Pointsystem: this.state.Pointsystem === '' || this.state.Pointsystem === null ? championship.Pointsystem : this.state.Pointsystem,
                KunSportsduer: this.state.KunSportsduer === null ? championship.KunSportsduer : Number(this.state.KunSportsduer),
                AntalDuerPrSlag: this.state.AntalDuerPrSlag === '' ? null : Number(this.state.AntalDuerPrSlag),
            };
            this.props.dispatch(AdminActions.updateChampionshipRace(championship.RecNr, raceNo, entity, (entity) => {
                NotificationManager.success(`Regler for mesterskabskapflyvningen ${race.Uge} - ${race.Farvekode} ${station.Navn} er opdateret.`, "Opdatering", 4000);
                this.setState({editIx: null});
            }))
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        stations: state.admin.stations
    },
    race: {
        isRacesRead: state.race.isRacesRead,
        races: state.race.races
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(ChampionshipRaces);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/championships/subPages/ChampionshipRaces.js